export const YOUTUBE_PRIVACY_STATUS_MAP = {
  public: 'Public',
  unlisted: 'Unlisted',
  private: 'Private',
} as const
